import { cn, formatDateCompact } from '@/shared/utilities';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import type { Message } from '../../models/message';

export const MessageMarker = ({ message, className }: { message?: Message; className?: string }) => {
  if (!message || !message.showDateMarker) return null;
  return (
    <Box className={cn('mex:my-4 mex:flex mex:justify-center', className)}>
      <Typography
        component='time'
        dateTime={dayjs(message.sentAt).toISOString()}
        variant='caption'
        className='mex:rounded-full mex:bg-gray-100 mex:px-3 mex:py-1 mex:font-medium mex:text-gray-600 mex:text-xs mex:dark:bg-gray-800 mex:dark:text-gray-400'
      >
        {formatDateCompact(message.sentAt)}
      </Typography>
    </Box>
  );
};
